import PocketBase from 'pocketbase';

const baseUrl = import.meta.env.PROD
  ? import.meta.env.VITE_POCKETBASE_PROD_URL
  : import.meta.env.VITE_POCKETBASE_URL;

if (!baseUrl) {
  throw new Error('PocketBase URL not configured in environment variables');
}

export const pb = new PocketBase(baseUrl);
